<f-data-card class="pos-relative">
  <!-- Based on inbound call/outbound call need to show only one heading -->
  <div class="card-header">
    <h2 class="heading">About the Interaction</h2>


    <button mat-button1 color="primary" class="show-hide" id="toggle-1"
      (click)="rootScope.activeCustTab.showContent = !rootScope.activeCustTab.showContent">
      <span *ngIf="!rootScope.activeCustTab.showContent"><i class="fa-regular fa-angle-down"></i></span>
      <span *ngIf="rootScope.activeCustTab.showContent"><i class="fa-regular fa-angle-up"></i></span>
    </button>
  </div>

  <div class="about-interaction show-hide-data" *ngIf="rootScope.activeCustTab.showContent">
    <section *ngIf="rootScope.customerTypeAPIFailure" class="error-wrapper">
      <f-alert variant="error">
        {{errorMsg}}
        <button (click)="apiService.getCustomerTypesAPI()" class="btn-alert">Try again</button>
      </f-alert>
    </section>

    <div class="error-wrapper" *ngIf="cusAccService.authSucessMsg()">
      <f-alert variant="success">{{validationSuccessMessage}}</f-alert>
    </div>

    <div class="auth-card">
      <div class="card-row">
        <div class="card-left">
          <h3>Authentication Status</h3>
        </div>

        <div class="card-right">
          <p class="auth-status">
            <span [ngClass]="
                cusAccService.identifyAuthenticateClass(
                  rootScope.activeCustTab.authenticateStatus
                )
              "></span>

            {{ rootScope.activeCustTab.authenticateStatus }}
          </p>

          <!-- <p class="auth-status">
            <span class="secured"></span>
            Fully secured           
          </p> -->
          <!-- Added "rootScope.activeCustTab?.channel == channel.call" codition to show only call scenario for US CCR3-6018 -->
          <p *ngIf="rootScope.activeCustTab?.genesysAttributes?.CP_INDICATIVE_DATA_SECURED == true && rootScope.activeCustTab?.channel == channel.call"
            class="font-normal auth-method"> [Indicative Data] </p>

        </div>
      </div>
      <div class="card-row">

        <div class="card-left">
          <p>Who is it?</p>

          <!--label (Caller/Customer Type) name change for CCR1-5039-->
          <app-alight-drop-down [group]="rootScope.customerTypeForm" [controlName]="'customerType'" [required]="false"
            description="fieldValueDescription" [disable]="cusAccService.callerTypeValidation()"
            label="Caller/Customer Type" [value]="'fieldValue'" [list]="rootScope.customerTypeData"
            (change)="changeCustomerType($event)">
          </app-alight-drop-down>
        </div>
        <div class="card-right">
          <f-button *ngIf="
              (rootScope.activeCustTab?.activeCall ||
                rootScope.activeCustTab?.activeChat) &&
              !rootScope.activeCustTab.additionalAccount
            " (click)="goToAuthenticatePage()" [iconConfig]="iconConfig" class="hide1" text="View authentication"
            type="button" variant="action"></f-button>
        </div>
      </div>
    </div>
    <div class="row-divider"></div>
    <div class="interaction-card">
      <div class="card-row">
        <div class="card-left">
          <h3>Interaction Status</h3>
        </div>
        <div class="card-right">
          <!-- when call is active  -->
          <p class="call-status" *ngIf="
              rootScope.activeCustTab.activeCall ||
              rootScope.activeCustTab.activeChat
            ">
            <span *ngIf="
                rootScope.activeCustTab.iconClass == 'red' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'call')
              ">
              <i class="fa fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i>
            </span>
            <span *ngIf="
            rootScope.activeCustTab.iconClass == 'fa-light' &&
            rootScope.activeCustTab.active &&
            liveIcon(rootScope.activeCustTab, 'call')
          ">
              <i class="fa fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i>
            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass == 'green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'call')
              ">
              <i class="fa fa-phone" [ngClass]="rootScope.activeCustTab.iconClass"></i>
            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass == 'fa-solid green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'chat')
              ">
              <i class="far fa-comment" [ngClass]="rootScope.activeCustTab.iconClass"></i>
            </span>
            <span *ngIf="
                rootScope.activeCustTab.iconClass != 'fa-solid green' &&
                rootScope.activeCustTab.active &&
                liveIcon(rootScope.activeCustTab, 'chat')
              ">
              <i class="far fa-comment" [ngClass]="rootScope.activeCustTab.iconClass"></i>
            </span>
            <span> {{ getInteractionStatus() }}</span>
          </p>

          <!-- In researche mode below text will be visible  -->
          <p class="auth-status"
            *ngIf="!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.activeChat &&  !this.isConversationIdPresent()">
            <span class=""></span> {{ getInteractionStatus() }}
          </p>

          <!----When call/Chat gets disconnected -->
          <p class="auth-status disconnect"
            *ngIf="!this.rootScope.activeCustTab.activeCall && !this.rootScope.activeCustTab.activeChat && this.isConversationIdPresent()">
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.call  && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL==securityLevel4">
              <i class="fa fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i></span>
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.call  && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL!=securityLevel4">
              <i class="fa fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i></span>
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.call  && !rootScope.activeCustTab.interactionDisconnected">
              <i class="fa fa-phone fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i></span>
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.chat && !rootScope.activeCustTab.interactionDisconnected">
              <i class="far fa-comment fa-light" [ngClass]="this.rootScope.activeCustTab.iconClass"></i>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.chat && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL=='4'">
              <i class="far fa-comment green"></i>
            </span>
            <span
              *ngIf="rootScope.activeCustTab.channel == channel.chat && rootScope.activeCustTab.interactionDisconnected && rootScope.activeCustTab.CS_SECURITY_LEVEL=='1'">
              <i class="far fa-comment red"></i>
            </span>
            {{ getInteractionStatus() }}

          </p>
        </div>
      </div>
      <div class="card-row">
        <div class="card-left">
          <p>What role?</p>
          <form [formGroup]="form">
            <mat-form-field appearance="fill" class="component-box">
              <mat-label>Role Type</mat-label>
              <mat-select disableRipple disableOptionCentering (focusout)="onRoleChangeFocusOut($event)"
                (keydown)="onKeyBoardRoleChange($event)" name='role' disableRipple formControlName="roleType"
                disableOptionCentering [(ngModel)]="defaultRole" (selectionChange)="onRoleChange($event)"
                (mouseenter)="clicked($event)" [disabled]='cusAccService.roleTypeValidation()'>
                <mat-option *ngFor="let roletype of cusAccService?.activeTabDt?.roleTypeList"
                  [value]="roletype.roleName" [title]="roletype.roleName">
                  {{ roletype.roleName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </form>
        </div>
        <div class="card-right" *ngIf="rootScope.indicatorClass == 'green' && ( !rootScope.activeCustTab.activeCall &&
        !rootScope.activeCustTab.activeChat &&
        !isConversationIdPresent())">

          <f-button text="Call this customer" type="button" variant="progressive" disabled="false"
            (click)="triggerOutboundCall()"></f-button>
        </div>
      </div>
    </div>
  </div>

  <app-card-loader class="hide"></app-card-loader>

  <app-loader *ngIf="rootScope.custAccInteractionLoader || cusAccService.firstLoadLoader" [loaderType]="loaderType"
    [loaderMsg]="rootScope.showCustAccInteractionLoaderMsg"></app-loader>
</f-data-card>